import React, { useEffect, useState, useRef, useContext } from "react";
import styles from "./styles/AddAsset.module.css";
import Info from "../Info/info";
import Upload from "../Upload/upload";
import FileIcon from "../File/file";
import { Beneficiarytrustee } from "../Beneficiarytrustee/Beneficiarytrustee";
import CredentialsMenu from "./CredentialsMenu";
import PartnerSharing, {
  EMPTY_PARTNER_SHARING,
  getPartner,
} from "../Partner Sharing/PartnerSharing";
import AddBeneficiary from "./AddBeneficiary";
import AssetEvaluation, {
  EMPTY_EVALUATION,
} from "../Asset Evaluation/AssetEvaluation";
import {
  mergeDebtIntoAsset,
  mergeEvaluationIntoAsset,
  mergeReadingIntoAsset,
  resolveAssetTypeSelection,
  ASSET_TYPE_CUSTOM,
  ownerOptionsFrom,
  assetTypeGroupsFor,
  ASSET_TYPE_MENU_HEIGHT,
} from "../../../Utils/assetEvaluationUtils";
import Dropdown from "../Asset Evaluation/Dropdown";
import { getAssetTypeTranslated } from "../../../Utils/translationUtils";
import { GenerateID, RandomId } from "../../../Utils/RandomId";
import { UserData } from "../../../Context/DataContext";
import { OnProgress } from "../My Account/OnProgress";
import { UploadFiles } from "../../../Utils/UploadFile";
import { handleIssues } from "../../../Utils/handleIssues";
import { isValidFileSize } from "../../../Utils/isValidFileSize";
import { floatMessage } from "../../../Utils/floatMessage";
import { encryptAsset } from "../../../Utils/dataEncryption";
import parse from "html-react-parser";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import missingFilesIcon from "./styles/img/missing_files.svg";
import { Button, Checkbox, Modal } from "antd";
import useWindowDimensions from "../../Footer/footer";
import { useScrollLock } from "../../../Utils/useScrollLock";
import { useSmoothHeight } from "../../../Utils/useSmoothHeight";

/*
  `onCreated` is called with the new asset's id once it exists, for the
  callers that opened this modal from inside another record -- a beneficiary's
  asset list, say, which has to attach what was just created. Everyone else
  leaves it out and nothing changes for them.

  The id is not the same thing on both paths. A customer generates it here; a
  partner's is assigned by the server, which discards whatever the browser
  sent, so theirs is read off the answer.
*/
function AddAsset({ onClose, onCreated, asset_type = "Bank Account" }) {
  const { height, width } = useWindowDimensions();
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const divElementRef = useRef(null);
  const boxRef = useRef(null);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddAsset.AddAsset
  );
  const [openModal, setOpenModal] = useState(false);
  // Frontend-only for now: held apart from `asset` so it is not sent on save.
  // Folded into the asset on save by mergeEvaluationIntoAsset.
  const [assetEvaluation, setAssetEvaluation] = useState(EMPTY_EVALUATION);
  /*
    Custom asset type. Picking "Custom" swaps the dropdown for a free-text
    field; the X puts the dropdown back. The typed name becomes one of this
    user's own types on save, and is offered in the dropdown from then on.
  */
  const [customType, setCustomType] = useState(false);
  const [customTypeLabel, setCustomTypeLabel] = useState("");
  /*
    Partner sharing. Frontend only — not part of the save payload yet, and the
    partner's name/picture are placeholders until the backend exposes the
    relationship. See docs/partner-sharing-backend-spec.md.
  */
  const [partnerSharing, setPartnerSharing] = useState(EMPTY_PARTNER_SHARING);
  const assetEvaluationRef = useRef(null);

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddAsset.AddAsset);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const handleScroll = () => {
    const divElement = divElementRef.current;
    const scrollTop = divElement.scrollTop;
    const scrollHeight = divElement.scrollHeight;
    const clientHeight = divElement.clientHeight;
    const threshold = 10; // Adjust the threshold as needed

    setShowTopShadow(scrollTop > 0);
    setShowBottomShadow(scrollTop + clientHeight < scrollHeight - threshold);
  };

  useEffect(() => {
    const divElement = divElementRef.current;

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, [height]);

  // const [show, setShow] = useState(true)
  const [modal, setModal] = useState(null);
  const [duplicatedName, setDuplicatedName] = useState(false);
  const duplicateError = content.addAssetError1;
  const userData = UserData();
  /*
    Null for a user with no partner, and the section is then not rendered at
    all: its heading and its note both name the partner, so with nobody to name
    there is nothing for it to say. See getPartner.
  */
  const partner = getPartner(userData);
  const index_ = userData?.UserData?.assets.map((asset) => {
    return asset.asset_id;
  });
  const customer_id = userData?.UserData?.user_id;
  const [error, setError] = useState({
    asset_name: "",
    asset_type: "",
    description: "",
  });
  const [formErrors, setFormError] = useState({
    service_name: "",
    username: "",
    password: "",
    record_name: "",
  });
  const [asset, setAsset] = useState({
    asset_id: GenerateID(customer_id, "A", index_),
    asset_name: "",
    asset_type: asset_type,
    description: "",
    credentials: '{"record_name":"This assets has no credentials"}',
    beneficiaries: [],
    trustees: [],
    asset_files: [],
  });
  const maxFilesToUpload = "8";
  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const textareaRef = useRef(null);

  const handleChangeDescription = () => {
    const textarea = textareaRef.current;
    // Reset the textarea height to 0 to correctly calculate the scrollHeight
    textarea.style.height = "0";
    const height = textarea.scrollHeight;
    textarea.style.height = `${height}px`;
  };
  // textarea

  /*
    The Save under the currency in the evaluation panel, in CREATE mode.

    Nothing is written to the database, because there is nothing to write it
    against: the asset does not exist yet, and its id is a local guess until it
    does. The reading goes onto the asset being built, so it shows on the chart
    and in the history table immediately -- and closing the modal without
    saving throws it away with everything else typed here, which is what closing
    an unsaved form has always meant.

    They are not lost on the way out, though: the records live on `asset`, which
    is what handleUpload saves, so every reading taken here is written along
    with the asset itself.
  */
  const saveReading = (evaluation) => {
    setAsset((previous) => {
      const { asset: withReading } = mergeReadingIntoAsset(
        previous,
        evaluation,
        userData.UserData?.financial_exposure_custom_options
      );
      /*
        The exposure OPTIONS are deliberately dropped here. A custom type the
        user typed becomes theirs when the asset is saved, not before -- adding
        it now would leave a stray type on the account for an asset they went on
        to abandon. handleUpload creates it, from the same field, on the way out.
      */
      return withReading;
    });
    /*
      Said out loud, as Edit Asset says it.

      The button is labelled Save and pressing it did nothing visible: the
      reading goes onto the asset being built, the history table a few lines
      down gains a row, but that table is below the fold while the fields
      are being filled in -- so the press read as having been ignored and
      the figure was entered again.

      The same word as everywhere else, deliberately. It IS saved, in the
      only sense available before the asset exists: it is held on the asset
      and goes to the server with it. Nothing here is written on its own --
      see deleteReading, which removes it the same way.
    */
    floatMessage(dublicatedcontent?.saved);
  };

  /*
    The Save inside the debt block, on the same terms as the reading above.

    It was missing here while Edit Asset had it, so the debt block on a NEW
    asset showed its fields and no way to commit them -- and since the
    asset's own Save does not demand the debt (deliberately: a half-filled
    debt must not block it), the figures could be typed and then simply not
    be there. The button is what the other modal uses to say they are kept.

    Nothing is persisted either way until the asset itself is saved; this
    folds the debt onto the asset being built, exactly as saveReading folds
    in a valuation, so it is already in place when the asset goes up.
  */
  const saveDebt = (evaluation) => {
    setAsset((previous) => mergeDebtIntoAsset(previous, evaluation));
    floatMessage(dublicatedcontent?.saved);
  };

  // Same terms: the record only ever existed in this form.
  const deleteReading = (record) => {
    if (!record?.id) return;
    setAsset((previous) => ({
      ...previous,
      asset_evaluation_records: (previous.asset_evaluation_records || []).filter(
        (entry) => entry.id !== record.id
      ),
    }));
  };

  /*
    And the debt series, on the same terms.

    Supplied alongside `debtRecords` rather than left out: the panel keeps
    its OWN copy of that list whenever no delete handler is given (see
    activeDebtRecords), so passing the list without this would have shown
    the asset's debts while deleting one only from the copy -- it would
    reappear the next time the asset changed.
  */
  const deleteDebtRecord = (record) => {
    if (!record?.id) return;
    setAsset((previous) => ({
      ...previous,
      asset_debt_records: (previous.asset_debt_records || []).filter(
        (entry) => entry.id !== record.id
      ),
    }));
  };

  const [files, setFiles] = useState([]);
  const [needToClear, setNeedToClear] = useState(false);

  const handleFile = (e) => {
    const file_array = Array.from(e.target.files);

    // show error if one of loaded files is more than 100mb
    const sizeError = isValidFileSize(file_array);
    if (sizeError) {
      setError({
        file_size: parse(sizeError),
      });
      setTimeout(() => {
        setError({
          file_size: "",
        });
      }, 10000);
      setNeedToClear(true);
      return;
    }

    const filesFreeSlots = maxFilesToUpload - files.length;
    if (
      file_array.length > maxFilesToUpload ||
      filesFreeSlots < file_array.length
    ) {
      setError({
        files: `${
          content.addAssetError2
        } ${maxFilesToUpload} ${dublicatedcontent?.dublicatedText94?.toLowerCase()}.`,
      });
      setTimeout(() => {
        setError({
          files: "",
        });
      }, 5000);
      return;
    }
    let asset_files = [];
    file_array.map((newFile) => {
      let asset_file = {
        id: RandomId(32),
        name: newFile.name,
        size: newFile.size,
        lastModified: newFile.lastModified,
      };
      asset_files.push(asset_file);
      let newBlob = new Blob([newFile], {
        type: newFile.type,
        lastModified: newFile.lastModified,
      });
      let renamedFile = new File([newBlob], asset_file.id, {
        type: newFile.type,
      });
      setFiles((files) => [...files, renamedFile]);
      return null;
    });
    setAsset({ ...asset, asset_files: asset.asset_files.concat(asset_files) });
  };
  const deleteFile = (fileO) => {
    console.log(files);
    const new_files = files.filter((file) => file.name !== fileO.id);
    console.log(new_files);
    setFiles(new_files);
    setAsset({
      ...asset,
      asset_files: asset.asset_files.filter((file) => file.id !== fileO.id),
    });
  };
  const editAsset = (key, value) => {
    setAsset((prevData) => {
      return { ...prevData, [key]: value };
    });
  };
  const trimNameField = (value) => {
    const name = value.trim();
    editAsset("asset_name", name);
  };
  const checkEmptyFields = () => {
    var isError = false;
    var error_aux = {
      asset_name: "",
      asset_type: "",
      description: "",
      files: "",
      credentials: "",
    };
    if (asset.asset_name === "") {
      error_aux.asset_name = content.addAssetError3;
      isError = true;
    }

    /*
      "Custom" is a prompt for a name, not a type. Unnamed it resolves to no
      type at all, and the save then quietly fell back to whichever type was
      selected before it — no error, the modal closed, and the asset was stored
      as something the user never chose.
    */
    if (customType && customTypeLabel.trim() === "") {
      error_aux.asset_type = content.addAssetError7;
      isError = true;
    }

    // check if asset with this name is exist
    if (userData.UserData.assets.length && asset.asset_name !== "") {
      const newAssetName = asset.asset_name;
      let hasMatchingAsset = userData.UserData.assets.some(
        (assetItem) =>
          assetItem.asset_name.toLowerCase() === newAssetName.toLowerCase()
      );

      if (hasMatchingAsset) {
        isError = true;
        setDuplicatedName(true);
        document.getElementById("scrollContainer").scrollTop = 0;
      }
    }

    if (asset.description.length > maxMessageLength) {
      error_aux.description = content.addAssetError4;
      isError = true;
    }
    if (asset.asset_files.length > maxFilesToUpload) {
      error_aux.files = content.addAssetError5;
      isError = true;
    }
    if (asset.description === "" && asset.asset_files.length === 0) {
      const showNotificationMessage =
        sessionStorage.getItem("show_notification");
      if (!showNotificationMessage) {
        // setOpenModal(true);
      }
      //   error_aux.description = content.addAssetError6;
      //   isError = true;
    }
    let aux_credentials = JSON.parse(asset.credentials);
    if (
      Object.keys(aux_credentials).some(
        (key) => key !== "mfa" && aux_credentials[key] === ""
      )
    ) {
      isError = true;
    }

    const newFormErrors = {
      service_name: "",
      username: "",
      password: "",
      record_name: "",
    };

    for (const field in aux_credentials) {
      if (aux_credentials[field] === "" && field !== "mfa") {
        newFormErrors[field] = "error";
      }
    }

    setFormError(newFormErrors);
    setError(error_aux);
    setTimeout(() => {
      setError({
        asset_name: "",
        asset_type: "",
        description: "",
        files: "",
        credentials: "",
      });
    }, 5000);
    return isError;
  };
  const Progress = (status) => {
    setModal(
      <OnProgress title={dublicatedcontent?.work_in_progress} status={status} />
    );
  };
  const uploadAsset = async () => {
    var new_beneficiaries;
    new_beneficiaries = userData.UserData.beneficiaries.map((beneficiary) => {
      if (asset.beneficiaries.includes(beneficiary.user_id)) {
        return {
          ...beneficiary,
          visible_assets: [
            ...new Set([...beneficiary.visible_assets, asset.asset_id]),
          ],
        };
      } else {
        return beneficiary;
      }
    });

    /*
      Fold the Asset Evaluation panel into the asset being saved. This also
      appends the first evaluation/debt record and, when the user typed a new
      custom exposure label, returns the user's exposure options with that type
      added — which is why the options are written back on the user document
      alongside the asset.
    */
    /*
      Resolve the asset type first: a typed custom name becomes one of this
      user's own types, or selects an existing one rather than duplicating it.
    */
    const { asset_type: resolvedType, options: assetTypeOptions } =
      resolveAssetTypeSelection(
        customType ? ASSET_TYPE_CUSTOM : asset.asset_type,
        customTypeLabel,
        userData.UserData?.asset_type_custom_options
      );

    /*
      Owners typed into the "Custom" field become names on the asset and join
      this user's saved owner list, so the next asset offers them.
    */
    const {
      asset: evaluatedAsset,
      exposureOptions,
      ownerOptions,
    } = mergeEvaluationIntoAsset(
      // The sharing switches ride along on the asset; they are stored unencrypted.
      {
        ...asset,
        ...partnerSharing,
        asset_type: resolvedType || asset.asset_type,
      },
      assetEvaluation,
      userData.UserData?.financial_exposure_custom_options,
      userData.UserData?.asset_owner_custom_options,
      ownerOptionsFrom(userData.UserData || {})
    );

    /*
      A partner adding an asset to their customer's account.

      An early return, like the beneficiary path: none of what follows may
      happen here. The asset counts towards nothing until the customer approves
      it, so their status is not recomputed, their custom type and owner option
      lists are not rewritten, and no beneficiary is attached -- that last one
      would be an edit to a record the customer owns, which a partner may never
      make.

      Encrypted under the CUSTOMER's key:  is theirs inside this
      view.
    */
    if (userData.partnerCreate) {
      Progress("Updating data ...");
      const encrypted = await encryptAsset(
        { ...evaluatedAsset, beneficiaries: [], credentials: "" },
        userData.private_key
      );
      /*
        The progress modal is cleared whatever happens. Left up on failure it
        reads as a save still running, and the partner waits on something that
        already finished -- which is exactly what a rejected record did.
      */
      let result;
      try {
        result = await userData.partnerCreate("asset", encrypted);
      } finally {
        setModal(null);
      }
      if (result?.ok) {
        floatMessage(dublicatedcontent?.saved);
        if (result.id) onCreated?.(result.id);
        onClose();
      } else {
        floatMessage(
          result?.detail ||
            dublicatedcontent?.an_error_occured_try_later ||
            "Something went wrong"
        );
      }
      return;
    }

    UploadFiles(files, userData.private_key, Progress, dublicatedcontent)
      .then(() => {
        Progress("Updating data ...");
        var new_issues = handleIssues(
          {
            ...userData.UserData,
            assets: [...userData.UserData.assets, evaluatedAsset],
            beneficiaries: new_beneficiaries,
          },
          userData.BillingData
        );
        userData.setUserData({
          ...userData.UserData,
          assets: [...userData.UserData.assets, evaluatedAsset],
          beneficiaries: new_beneficiaries,
          issues: new_issues,
          financial_exposure_custom_options: exposureOptions,
          asset_type_custom_options: assetTypeOptions,
          asset_owner_custom_options: ownerOptions,
        });
        userData.Update(RandomId(10));
        userData.setCustomerUser({
          ...userData.CustomerUser,
          user_status: [...userData.UserData.assets, evaluatedAsset].some(
            (e) => e.beneficiaries.length > 0
          )
            ? "Active"
            : "Inactive",
        });
        setModal(null);
        onCreated?.(evaluatedAsset.asset_id);
        onClose();
        floatMessage(dublicatedcontent?.saved);
      })
      .catch((e) => {
        // Progress('Something went wrong...')
        try {
          Progress(e.toString());
        } catch (e) {
          console.log(e);
        }

        setTimeout(() => {
          setModal(null);
          onClose();
        }, 1000);
      });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(asset);
    // Asset Evaluation ownership must total 100%; scrolls itself into view.
    if (
      assetEvaluationRef.current &&
      !assetEvaluationRef.current.validate()
    ) {
      return;
    }
    if (checkEmptyFields()) {
      return;
    }

    if (asset.description === "" && asset.asset_files.length === 0) {
      const showNotificationMessage =
        sessionStorage.getItem("show_notification");
      if (!showNotificationMessage) {
        setOpenModal(true);
        return;
      }
    }

    uploadAsset();
  };

  // Counted, so a nested modal closing does not unlock the page underneath
  // this one -- see Utils/useScrollLock.
  useScrollLock(!userData.isFreezed);
  // Grow and shrink smoothly when a section inside opens or closes.
  useSmoothHeight(boxRef, divElementRef);

  const clearNameError = () => {
    setDuplicatedName(false);
  };

  return (
    <>
      {!userData.isFreezed && (
        <div className={styles.background}>
          <Modal
            rootClassName="save_anyway_modal"
            style={{
              zIndex: 7,
            }}
            id="12"
            footer={[
              <div className={styles.notificationModal_footer}>
                <Checkbox
                  style={{
                    textAlign: "left",
                  }}
                  onClick={(e) => {
                    sessionStorage.setItem(
                      "show_notification",
                      e.target.checked
                    );
                  }}
                >
                  {content.addAssetText29}
                </Checkbox>
                <div className={styles.notificationModal_footer_buttons}>
                  <Button
                    onClick={(e) => {
                      setOpenModal(false);
                    }}
                    style={{ backgroundColor: "#0091EA" }}
                    type="primary"
                  >
                    {dublicatedcontent.dublicatedText71}
                  </Button>
                  <Button onClick={(e) => uploadAsset()}>
                    {content.addAssetText32}
                  </Button>
                </div>
              </div>,
            ]}
            onCancel={(e) => setOpenModal(false)}
            open={openModal}
            className={styles.notificationModal}
          >
            <div className={styles.notificationModal_container}>
              <img src={missingFilesIcon} alt="missingFiles" />
              <h2>{content.addAssetText30}</h2>
            </div>
            <p>{parse(content.addAssetText31)}</p>
          </Modal>

          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={
              width <= 599
                ? {
                    height: window.innerHeight - 10,
                  }
                : {}
            }
            ref={boxRef}
        className={styles.main_box}
          >
            <div onClick={onClose} className={styles.close_logo}></div>
            <div className={styles.title}>{content.addAssetText2}</div>
            <div
              className={styles.popup_scrollable}
              id="scrollContainer"
              ref={divElementRef}
            >
              <div
                className={`${styles.shadow_top} ${
                  showTopShadow ? styles.active : ""
                }`}
              />

              <div className={styles.main_data}>
                <div className={styles.main_data_upper}>
                  <div className={styles.upper_left}>
                    <div
                      className={`${styles.input_title} ${styles.required_field}`}
                    >
                      {dublicatedcontent.dublicatedText63}
                    </div>
                    <input
                      onBlur={(e) => trimNameField(e.target.value)}
                      value={asset.asset_name}
                      onClick={(e) => clearNameError()}
                      onChange={(e) => editAsset("asset_name", e.target.value)}
                      className={`${styles.beneficiary_input} ${
                        error.asset_name ? styles.field_error : ""
                      } ${duplicatedName ? styles.field_error : ""}`}
                      placeholder={dublicatedcontent.dublicatedText63}
                    ></input>
                    {duplicatedName ? (
                      <div className={styles.error_message}>
                        {duplicateError}
                      </div>
                    ) : null}
                    <div className={styles.error_message}>
                      {error.asset_name === "" ? "" : error.asset_name}
                    </div>
                  </div>
                  <div className={styles.upper_right}>
                    <div className={styles.delay_period}>
                      <div
                        className={`${styles.input_title} ${styles.required_field}`}
                      >
                        {dublicatedcontent.dublicatedText58}
                      </div>
                    </div>
                    {customType ? (
                      <div className={styles.custom_type_wrap}>
                        <input
                          autoFocus
                          type="text"
                          className={`${styles.select} ${
                            error.asset_type ? styles.field_error : ""
                          }`}
                          placeholder={
                            dublicatedcontent?.enter_a_name || "Enter a name"
                          }
                          value={customTypeLabel}
                          onChange={(e) => {
                            // Clear as soon as it has a name.
                            if (e.target.value.trim() && error.asset_type) {
                              setError((prev) => ({ ...prev, asset_type: "" }));
                            }
                            setCustomTypeLabel(e.target.value);
                          }}
                        />
                        {/* Back to the dropdown, discarding what was typed. */}
                        <button
                          type="button"
                          className={styles.custom_type_clear}
                          aria-label={dublicatedcontent?.cancel || "Cancel"}
                          title={dublicatedcontent?.cancel || "Cancel"}
                          onClick={() => {
                            setCustomType(false);
                            setCustomTypeLabel("");
                            setError((prev) => ({ ...prev, asset_type: "" }));
                            editAsset("asset_type", asset_type);
                          }}
                        />
                        <div className={styles.error_message}>
                          {error.asset_type}
                        </div>
                      </div>
                    ) : (
                    <Dropdown
                      value={asset.asset_type || asset_type}
                      onChange={(next) => {
                        if (next === ASSET_TYPE_CUSTOM) {
                          setCustomType(true);
                          setCustomTypeLabel("");
                          return;
                        }
                        editAsset("asset_type", next);
                      }}
                      groups={assetTypeGroupsFor({
                        currentValue: asset.asset_type || asset_type,
                        customOptions:
                          userData.UserData?.asset_type_custom_options,
                        translate: (value) =>
                          getAssetTypeTranslated(
                            value,
                            content,
                            dublicatedcontent
                          ),
                        customLabel: dublicatedcontent?.custom || "Custom",
                      })}
                      placeholder={dublicatedcontent.dublicatedText58}
                      triggerClassName={`${styles.select} ${styles.type_trigger}`}
                      maxMenuHeight={ASSET_TYPE_MENU_HEIGHT}
                      ariaLabel={dublicatedcontent.dublicatedText58}
                      title={getAssetTypeTranslated(
                        asset.asset_type || asset_type,
                        content,
                        dublicatedcontent
                      )}
                    />
                    )}
                  </div>
                </div>
                <div className={styles.main_data_lower}>
                  <div className={styles.input_title}>
                    {dublicatedcontent.dublicatedText59}
                  </div>
                  <textarea
                    placeholder={dublicatedcontent.dublicatedText59}
                    maxlength={maxMessageLength}
                    ref={textareaRef}
                    onChange={(e) => {
                      editAsset("description", e.target.value);
                      handleChangeDescription(e);
                    }}
                    // className={`${styles.large_message} ${
                    //   error.description ? styles.field_error : ""
                    // }`}
                    className={`${styles.large_message}`}
                  ></textarea>
                  <div
                    className={`${styles.counter} ${
                      asset.description.length === maxMessageLength
                        ? styles.error_text
                        : ""
                    }`}
                  >
                    {asset.description.length === maxMessageLength ? (
                      <>{content.addAssetText28} </>
                    ) : (
                      ""
                    )}
                    {asset.description.length}/{maxMessageLength}{" "}
                    {dublicatedcontent?.dublicatedText93}
                  </div>
                  <div className={styles.error_message}>
                    {error.description === "" ? "" : error.description}
                  </div>
                </div>
              </div>
              <div className={styles.upload_doc}>
                <div
                  className={styles.delay_period}
                  style={{ marginTop: "20px" }}
                >
                  <div className={styles.bold_title}>
                    {content.addAssetText25}
                  </div>
                  <Info message={content.addAssetText18} />
                </div>
                <div
                  className={styles.input_title}
                  style={{ letterSpacing: "-0.02em" }}
                >
                  {content.addAssetText19}
                </div>
                <div className={styles.file_container}>
                  {asset.asset_files.map((file) => {
                    return (
                      <FileIcon
                        key={file.id}
                        filename={file.name}
                        date={file.lastModified}
                        size={file.size}
                        OnDelete={() => {
                          console.log("File to be deleted:");
                          console.log(file);
                          deleteFile(file);
                        }}
                      ></FileIcon>
                    );
                  })}
                  {/*
                    No file upload when a partner is creating for a customer.
                    Files are stored against the uploading session, so anything
                    attached here would land in the PARTNER's storage under
                    their own id and the customer would never see it. Better to
                    not offer it than to lose it silently; the customer can add
                    files once they have approved the asset.
                  */}
                  {asset.asset_files.length <= maxFilesToUpload - 1 &&
                    !userData.partnerCreate && (
                      <Upload
                        handleFile={(e) => handleFile(e)}
                        clearField={needToClear}
                      />
                    )}
                </div>
                <div className={styles.error_message}>
                  {error.files === "" ? "" : error.files}
                </div>
                <div className={styles.file_counter}>
                  {content.addAssetText26}
                  <div
                    className={`${styles.file_counter} ${
                      asset.asset_files.length >= maxFilesToUpload
                        ? styles.error_text
                        : ""
                    }`}
                  >
                    {asset.asset_files.length}/{maxFilesToUpload}{" "}
                    {content?.addAssetText27}
                  </div>
                </div>
                {error.file_size ? (
                  <div
                    className={`${styles.error_message} ${styles.file_error}`}
                  >
                    {error.file_size}
                  </div>
                ) : null}
              </div>
              <AssetEvaluation
                ref={assetEvaluationRef}
                value={assetEvaluation}
                onChange={setAssetEvaluation}
                customExposureOptions={
                  userData.UserData?.financial_exposure_custom_options || []
                }
                /*
                  Readings taken before the asset exists. Held on the asset
                  being built, so the chart and the history table read them the
                  same way they do in Edit Asset -- and so they are already in
                  place when the asset is finally saved.
                */
                records={asset.asset_evaluation_records}
                debtRecords={asset.asset_debt_records}
                onSaveReading={saveReading}
                onSaveDebt={saveDebt}
                onDeleteDebtRecord={deleteDebtRecord}
                /* Whether the asset being built already holds a debt. */
                debtCommitted={asset?.has_associated_debt === true}
                onDeleteRecord={deleteReading}
              />
              <div
                className={styles.main_data_upper}
                style={{ position: "relative", zIndex: "2" }}
              >
                <div className={styles.add_field}>
                  <div
                    className={styles.delay_period}
                    style={{ marginTop: "20px", marginBottom: "10px" }}
                  >
                    <div className={styles.bold_title}>
                      {dublicatedcontent?.dublicatedText82}
                    </div>
                    <Info message={content.addAssetText20} />
                  </div>
                  <div className={styles.file_container}>
                    {asset.beneficiaries.map((beneficiary_id) => {
                      let name = "";
                      let priority;
                      let avatar = null;
                      userData.UserData["beneficiaries"].map((e, index) => {
                        if (e.user_id === beneficiary_id) {
                          name = e.name;
                          priority = e.priority;
                          const benefAvatar =
                            userData?.UserData?.beneficiaries?.filter(
                              (y) => y.user_id === e.user_id
                            )[0]?.profile_avatar;
                          avatar = benefAvatar;
                        }
                        return null;
                      });
                      return (
                        <Beneficiarytrustee
                          name={name}
                          priority={priority}
                          avatar={avatar}
                          deleatable={true}
                          onDelete={() =>
                            setAsset({
                              ...asset,
                              beneficiaries: asset.beneficiaries.filter(
                                (beneficiary_) =>
                                  beneficiary_ !== beneficiary_id
                              ),
                            })
                          }
                        />
                      );
                    })}
                    {asset?.beneficiaries.length <= 11 && (
                      <AddBeneficiary
                        setShow={(e) => null}
                        alreadySelected={asset.beneficiaries}
                        user_type={"beneficiaries"}
                        onSelect={(beneficiary) => {
                          setAsset({
                            ...asset,
                            beneficiaries: [
                              ...asset.beneficiaries,
                              beneficiary.user_id,
                            ],
                          });
                        }}
                      />
                    )}
                  </div>
                </div>
                <div className={styles.add_field}>
                  <div
                    className={styles.delay_period}
                    style={{ marginTop: "20px", marginBottom: "10px" }}
                  >
                    <div className={styles.bold_title}>
                      {dublicatedcontent.dublicatedText64}
                    </div>
                    <Info message={content.addAssetText22} />
                  </div>
                  <div className={styles.file_container}>
                    {asset.trustees.map((trustee_id) => {
                      let name = "";
                      let avatar = null;
                      userData.UserData["trustees"].map((e, index) => {
                        if (e.user_id === trustee_id) {
                          name = e.name;
                          avatar = userData?.UserData?.trustees?.filter(
                            (y) => y.user_id === e.user_id
                          )[0]?.profile_avatar;
                        }
                        return null;
                      });
                      return (
                        <Beneficiarytrustee
                          name={name}
                          priority={0}
                          deleatable={true}
                          avatar={avatar}
                          onDelete={() =>
                            setAsset({
                              ...asset,
                              trustees: asset.trustees.filter(
                                (trustee_) => trustee_ !== trustee_id
                              ),
                            })
                          }
                        />
                      );
                    })}
                    {asset?.trustees.length <= 24 && (
                      <AddBeneficiary
                        setShow={() => null}
                        alreadySelected={asset.trustees}
                        user_type={"trustees"}
                        onSelect={(trustee) => {
                          setAsset({
                            ...asset,
                            trustees: [...asset.trustees, trustee.user_id],
                          });
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/*
                No credentials when a partner is creating for a customer: the
                endpoint strips them off anything a partner sends, so offering
                the fields would only invite work that is thrown away.
              */}
              {!userData.partnerCreate && (
              <div
                className={styles.delay_period}
                style={{ marginTop: "20px", marginBottom: "10px" }}
              >
                <div className={styles.bold_title}>
                  {dublicatedcontent?.dublicatedText213}
                </div>
              </div>
              )}
              {!userData.partnerCreate && (
              <div style={{ position: "relative", zIndex: "1" }}>
                <CredentialsMenu
                  onChange={(value) => {
                    editAsset("credentials", JSON.stringify(value));
                    handleScroll();
                  }}
                  formErrors={formErrors}
                />
              </div>
              )}
              <div
                className={`${styles.error_message} ${
                  error.credentials !== ""
                    ? styles.error_message_credentials
                    : ""
                }`}
              >
                {error.credentials === "" ? "" : error.credentials}
              </div>

              {partner && (
                <PartnerSharing
                  value={partnerSharing}
                  onChange={setPartnerSharing}
                  disabled={userData.isFreezed}
                  partnerName={partner.name}
                  partnerAvatar={partner.avatar}
                />
              )}

              <div
                className={`${styles.shadow_bottom} ${
                  showBottomShadow ? styles.active : ""
                }`}
              />
            </div>

            <div className={styles.buttons_div}>
              <div onClick={onClose} className={styles.cancel_button}>
                {content.addAssetText23}
              </div>
              <div
                onClick={(e) => handleSubmit(e)}
                className={styles.save_button}
              >
                {content.addAssetText24}
              </div>
            </div>

            {modal ? (
              <div style={{ position: "relative", zIndex: "5" }}>{modal}</div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
}

export default AddAsset;
